import { render, staticRenderFns } from "./ProjectPlanning.vue?vue&type=template&id=2c53b592&"
import script from "./ProjectPlanning.vue?vue&type=script&lang=js&"
export * from "./ProjectPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports